// import React from 'react'

const ErrorBoundary = ({ children }) => {
    return children
  }
  
  export default ErrorBoundary
  